import * as Sentry from '@sentry/react'
import {config} from './config'

if (['staging', 'production'].includes(config.common.environment)) {
  Sentry.init({
    dsn: config.common.sentryDsn,
    environment: config.common.environment,
    integrations: [new Sentry.Replay()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    initialScope: {
      tags: {
        brand: config.brand,
        whiteLabel: config.key,
      },
    },
  })
}

export default Sentry
